import React, { useEffect, useState } from 'react';
import { Notice } from '../../components/ui/Notice';
import { Badge } from '../../components/ui/Badge';
import { getBookings } from '../../api/bookings';
import { Booking } from '../../types';
import { formatCurrency, formatDate } from '../../utils/format';

export const CustomerBookings: React.FC = () => {
  const [bookings, setBookings] = useState<Booking[]>([]);
  useEffect(() => { getBookings().then(r => setBookings(r.data.results || r.data)); }, []);

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>Booking Saya</h1>
      <Notice type="info">Harga yang ditampilkan adalah harga final. Detail markup dan komisi tidak ditampilkan.</Notice>
      {bookings.length === 0 && (
        <div style={{ background: '#fff', border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, padding: 40, textAlign: 'center', color: '#888780' }}>
          Belum ada booking
        </div>
      )}
      {bookings.map(b => (
        <div key={b.id} style={{ background: '#fff', border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, padding: 20, marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 2 }}>{b.hotel_name}</div>
              <div style={{ fontSize: 12, color: '#888780', fontFamily: 'monospace' }}>{b.booking_code}</div>
            </div>
            <Badge status={b.status} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 14 }}>
            <div><div style={{ fontSize: 11, color: '#888780' }}>Kamar</div><div style={{ fontSize: 13, fontWeight: 500 }}>{b.room_type}</div></div>
            <div><div style={{ fontSize: 11, color: '#888780' }}>Checkin</div><div style={{ fontSize: 13 }}>{formatDate(b.checkin_date)}</div></div>
            <div><div style={{ fontSize: 11, color: '#888780' }}>Checkout</div><div style={{ fontSize: 13 }}>{formatDate(b.checkout_date)}</div></div>
            <div><div style={{ fontSize: 11, color: '#888780' }}>Tamu</div><div style={{ fontSize: 13 }}>{b.guest_name}</div></div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 12, borderTop: '0.5px solid rgba(0,0,0,0.08)' }}>
            <div style={{ fontSize: 12, color: '#888780' }}>{b.nights} malam · {b.currency}</div>
            <div style={{ fontSize: 18, fontWeight: 500 }}>{formatCurrency(b.total_price, b.currency)}</div>
          </div>
          {b.status === 'pending' && <Notice type="warn" style={{ marginTop: 12, marginBottom: 0 }}>Menunggu konfirmasi pembayaran</Notice>}
        </div>
      ))}
    </div>
  );
};
